import toolUrl from './modules/tool-url';
import { getEdgeVersion } from './utils/browser';

async function bootUp () {
  // @ts-ignore
  // eslint-disable-next-line import/no-dynamic-require
  await new Promise(resolve => require(['./init'], resolve));

  const edgeVersion = getEdgeVersion();

  if (edgeVersion !== null && edgeVersion <= 18) {
    // @ts-ignore
    // eslint-disable-next-line import/no-dynamic-require
    await new Promise(resolve => require(['./index-legacy'], resolve));
    return;
  }

  toolUrl.readUrl();

  // @ts-ignore
  // eslint-disable-next-line import/no-dynamic-require
  require(['dojo/ready', 'eCounty/Main'], (ready, Main) => {
    // @ts-ignore
    const serverData = window.serverData;

    ready(() => {
      Main.init({ serverData });
    });
  });
}

bootUp();
